<template>
  <v-popover
    :disabled="disabled"
    :open="openTutorial === order"
    :autoHide="false"
    :placement="placement"
    trigger="manual"
    :offset="offset"
    popoverClass="tutorial-tooltip"
    :class="wrapperClasses"
  >
    <div :class="'with-tutorial ' + 'tutorial'+ order" :ref="'tutorial'+ order">
      <slot></slot>
    </div>
    <template slot="popover">
      <h3>
        {{ heading }}
      </h3>
      <p>
        {{ text }}
      </p>
      <span class="close-tutorial" @click="handleTutorialExit">
        <v-icon>clear</v-icon>
      </span>
      <div class="popup-footer">
        <a class="absolute-left back-link" v-if="openTutorial > 1" @click="handlePreviousClick">Go Back</a>
        <div class="absolute-right">
          <button class="btn-neutral-light" v-if="!last" @click="handleNextClick">Next</button>
          <button v-else @click="handleTutorialExit">Done</button>
        </div>
      </div>
    </template>
  </v-popover>
</template>

<script>
  export default {
    name: 'WithTutorial',
    props: {
      name: {
        required: true,
        type: String
      },
      order: {
        required: true,
        type: Number
      },
      text: {
        default: 'tutorial text',
        type: String
      },
      last: {
        default: false,
        type: Boolean
      },
      heading:{
        type: String,
        default: 'popup heading'
      },
      offset: {
        type: String,
        default: '0'
      },
      placement: {
        type: String,
        default: 'right'
      },
      inline: {
        type: Boolean,
        default: false
      },
      block: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        openTutorial: 1,
        disabled: false
      }
    },
    computed: {
      wrapperClasses() {
        if (this.inline) {
          return 'force-inlineblock'
        }
        else if (this.block) {
          return 'force-block'
        }
        return null
      }
    },
    created() {
      this.$events.on('updateTutorial.' + this.name, (tutorialNumber, disabled) => {
        console.debug('event [%s][%s][%s]', 'updateTutorial.' + this.name, tutorialNumber, disabled)
        this.openTutorial = tutorialNumber
        this.disabled = disabled
      })
    },
    mounted() {
      // TODO: find a better way to do this,
      // this is made like this to prevent the need to pass so many props to all tooltip instances
      // this.disabled = this.$parent.tooltipsDisabled
      const key = 'PfxTutorialsDisabled.' + this.name
      const value = localStorage.getItem(key)
      console.warn('WithTutorial mounted [%s]=[%s]', key, value)
      this.disabled = value === 'true'
    },
    beforeDestroy() {
      // TODO removing event seems not to work? when navigation back and forth in pages ...
      // logs will show multiple console logs about updateTutorial event handlers (which
      // indicates that this.$events.on is incrementing a new handler function each time the
      // component is mounted.
      this.$events.off('updateTutorial.' + this.name)
    },
    methods: {
      handleNextClick() { this.$events.emit('gotonext.' + this.name) },
      handlePreviousClick() { this.$events.emit('gotoprevious.' + this.name) },
      handleTutorialExit() { this.$events.emit('toggleTutorial.' + this.name) }
    }
  }
</script>

<style lang="scss">
  .with-tutorial{
    // display: inline-block;
  }
  .back-link{
    cursor: pointer;
  }
  .force-inlineblock{
    // this is used when a trigger element should be inline with it's friends! use with "inline"-prop
    display: inline-block;
  }
  .force-block .trigger{
    // this is for cases when we attach tutorial into block element that needs to fill its container width. Use with "block"-prop
    display: block!important;
  }
  .close-tutorial{
    position: absolute;
    top: 5px;
    right: 5px;
    cursor: pointer;
  }
  .popup-footer{
    min-height: 2rem;
    position: relative;
    padding: 4px;
    .absolute-left{
      position: absolute;
      left:0;
    }
    .absolute-right{
      position: absolute;
      right:0;
    }
  }
  .tutorial-tooltip.tooltip{
    max-width: 300px;
    .tooltip-inner{
      background-color: #FAFFF9!important;
    }
    .tooltip-arrow {
      border-style: solid;
      position: absolute;
      border-color: #FAFFF9;
      z-index: 1;
    }
    &[x-placement^="right"] {
      margin-left: 5px;
      .tooltip-arrow {
        border-width: 15px 15px 15px 0;
        border-left-color: transparent !important;
        border-top-color: transparent !important;
        border-bottom-color: transparent !important;
        left: -15px;
        margin-left: 0;
        margin-right: 0;

      }
    }
    &[x-placement^="left"] {
      margin-right: 5px;
      .tooltip-arrow {
        border-width: 15px 0 15px 15px;
        border-top-color: transparent !important;
        border-right-color: transparent !important;
        border-bottom-color: transparent !important;
        right: -15px;
        top: calc(50% - 15px);
        margin-left: 0;
        margin-right: 0;
      }
    }
    &[x-placement^="top"] {
      margin-bottom: 15px;
      .tooltip-arrow {
        border-width: 15px 15px 0 15px;
        border-left-color: transparent !important;
        border-right-color: transparent !important;
        border-bottom-color: transparent !important;
        bottom: -15px;
        left: calc(50% - 15px);
        margin-top: 0;
        margin-bottom: 0;
      }
    }
    &[x-placement^="bottom"] {
      margin-top: 15px;
      .tooltip-arrow {
        border-width: 0 15px 15px 15px;
        border-left-color: transparent !important;
        border-right-color: transparent !important;
        border-top-color: transparent !important;
        top: -15px;
        left: calc(50% - 15px);
        margin-top: 0;
        margin-bottom: 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/elements/WithTutorial.vue